import React from "react";
import { TabState, TopSelector, BottomSelector } from "./models/NestedTabModels";
import classNames from "classnames";

interface NestedTabsState {
  activeVariantIndex: number;
  activeTabIndex: number;
  tabState: TabState[];
}

interface NestedTabsProps {
  topSelector: TopSelector[];
  bottomSelector: BottomSelector[];
}

export class NestedTabs extends React.Component<NestedTabsProps, NestedTabsState> {
  constructor(props: NestedTabsProps) {
    super(props);

    this.state = {
      activeVariantIndex: 0,
      activeTabIndex: 0,
      tabState: [{ iFrameClicked: false }, { iFrameClicked: false }],
    };
  }

  log = (message: string): void => {
    document.location.href.indexOf("?log") > -1 && console.log(`Nested Tabs : ${message}`);
  };

  setActiveTab = (activeTabIndex: number): void => {
    this.setState({ activeTabIndex });
  };

  setActiveVariant = (activeVariantIndex: number): void => {
    this.setState({
      activeVariantIndex,
      activeTabIndex: 0,
    });
  };

  enableIframe = (activeTabIndex: number): void => {
    this.setState({ tabState: [{ iFrameClicked: activeTabIndex === 0 }, { iFrameClicked: activeTabIndex === 1 }] });
  };

  render() {
    const renderVariantSelector = () => {
      const { topSelector } = this.props;
      const headerClass = classNames({
        tabs__nestedTitle: topSelector.length > 1
      });
      return (
        <div>
          {topSelector &&
            topSelector.length > 0 &&
            topSelector.map((variant, index) => {
              return (
                <div key={`tab${index}`}
                  className={headerClass}>
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      this.log(`Clicked ${variant.text}`);
                      this.setActiveVariant(index);
                    }}
                    className={`tabs__headerItem ${
                      index === this.state.activeVariantIndex ? "tabs__headerItem--active" : ""
                    }`}
                  >
                    <span dangerouslySetInnerHTML={{ __html: variant.text }} />
                  </div>
                </div>
              );
            })}
        </div>
      );
    };

    const getViewImage = () => {
      const { topSelector } = this.props;
      return this.state.activeTabIndex === 0
        ? topSelector[this.state.activeVariantIndex].interior.viewImage
        : topSelector[this.state.activeVariantIndex].exterior.viewImage;
    };

    const getViewDisclaimer = () => {
      const { topSelector } = this.props;
      return this.state.activeTabIndex === 0
        ? topSelector[this.state.activeVariantIndex].interior.viewDisclaimer
        : topSelector[this.state.activeVariantIndex].exterior.viewDisclaimer;
    };

    const getViewUrl = () => {
      const { topSelector } = this.props;
      return this.state.activeTabIndex === 0
        ? topSelector[this.state.activeVariantIndex].interior.viewUrl
        : topSelector[this.state.activeVariantIndex].exterior.viewUrl;
    };

    const renderImage = (index: number, tab: BottomSelector) => {
      const disclaimerClass = classNames({
        "three60__disclaimer": !this.state.activeTabIndex,
        "three60__disclaimer-reverse": this.state.activeTabIndex
      });
      return (
        <div
          className="three60__info"
          onClick={() => {
            this.enableIframe(index);
            this.log(`Clicked ${tab.nodeName}`);
          }}
          style={{ backgroundImage: `url(${getViewImage()})` }}
        >
          <div className="three60__infoBox">
            Load
            <br />
            360&deg; View
          </div>
          <div className={disclaimerClass}>{getViewDisclaimer()}</div>
        </div>
      );
    };

    const renderIframe = () => {
      return <iframe className="three60__content three60__content" src={getViewUrl()} frameBorder="none"></iframe>;
    };

    const render360DegreeView = () => {
      const { bottomSelector, topSelector } = this.props;
      const headerClass = classNames({
        tabs__header: bottomSelector.length > 1,
        tabs__headerNoPointer: bottomSelector.length === 1
      });
      return (
        <div className="tabs">
          <div className={headerClass}>
            {bottomSelector.map((tab, index) => {
              return (
                <div
                  onClick={() => this.setActiveTab(index)}
                  key={`tab${index}`}
                  className={`tabs__headerItem ${
                    index === this.state.activeTabIndex ? "tabs__headerItem--active" : ""
                  }`}
                >
                  <span dangerouslySetInnerHTML={{ __html: tab.text }} />
                </div>
              );
            })}
          </div>

          {bottomSelector.map((tab, index) => {
            return (
              this.state.activeTabIndex === index && (
                <section key={`tabItem${index}`} className="tabs__item" data-tabTitle={tab.text}>
                  <div id={tab.nodeName} className="three60">
                    {!this.state.tabState[index].iFrameClicked ? renderImage(index, tab) : renderIframe()}
                  </div>
                </section>
              )
            );
          })}
        </div>
      );
    };

    return (
      <div>
        {renderVariantSelector()}
        {render360DegreeView()}
      </div>
    );
  }
}
